"use client";

/* Dipecah dari page.jsx karena halaman ini mengekspor `metadata`.
   Next.js melarang metadata di Client Component, sementara
   useLanguage() hanya hidup di Client Component. Pola yang sama
   dipakai di app/tentang-kami/about/. */

import Link from "next/link";
import GalleryGrid from "../../components/GalleryGrid";
import Footer from "../../components/Footer";

import { useLanguage } from "../../i18n/LanguageProvider";

export default function GalleryContent() {
  const { t } = useLanguage();

  return (
    <div className="w-full bg-[var(--c-surface)] pt-[64px] md:pt-[112px]">

      {/* ---------- BARIS BREADCRUMB ---------- */}
      <div className="border-b border-[var(--c-line)] bg-[var(--c-tint)]">
        <div className="mx-auto max-w-[1600px] px-4 py-3 sm:px-6 sm:py-3.5 lg:px-10">
          <Breadcrumb
            items={[
              { label: t("header.nav.home"), href: "/" },
              { label: t("about.eyebrow"), href: "/tentang-kami" },
              { label: t("header.tentang.gallery") },
            ]}
          />
        </div>
      </div>

      <section className="mx-auto max-w-[1600px] px-4 py-10 sm:px-6 sm:py-14 md:py-16 lg:px-10">

        {/* ---------- KEPALA ----------
           max-w-2xl pada paragraf mengunci panjang baris di sekitar
           70 karakter. Judul dibiarkan penuh karena pendek. */}
        <div className="mb-8 sm:mb-10 md:mb-12">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-[var(--c-brand-mid)] sm:mb-3 sm:text-xs sm:tracking-[0.18em]">
            {t("about.eyebrow")}
          </p>

          <h1 className="text-balance text-3xl font-bold leading-[1.1] tracking-tight text-[var(--c-ink)] sm:text-4xl md:text-5xl">
            {t("galeri.judul")}
          </h1>

          <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-[var(--c-body)] sm:mt-5 sm:text-base md:text-[17px]">
            {t("galeri.sub")}
          </p>
        </div>

        <GalleryGrid />
      </section>

      <Footer />
    </div>
  );
}

function Breadcrumb({ items = [] }) {
  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="text-[13px] sm:text-sm">
      <ol className="flex flex-wrap items-center gap-y-1">
        {items.map((item, i) => {
          const terakhir = i === items.length - 1;

          return (
            <li key={`${item.label}-${i}`} className="flex items-center">
              {i > 0 && (
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="mx-2 h-3.5 w-3.5 shrink-0 text-[var(--c-faint)] sm:mx-2.5">
                  <path d="m9 6 6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}

              {terakhir || !item.href ? (
                <span aria-current={terakhir ? "page" : undefined} className="font-bold text-[var(--c-brand)]">
                  {item.label}
                </span>
              ) : (
                <Link href={item.href} className="rounded text-[var(--c-muted)] underline-offset-4 transition-colors hover:text-[var(--c-brand)] hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)]">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
